<div class="flex flex-col sm:flex-row items-start sm:items-center sm:justify-between pt-4 px-6 md:px-8">

    <div>
        <div class="flex items-start">
            <div class="text-2xl font-bold tracking-tight leading-none" *ngIf="showTitle">
                {{title|translate}}
            </div>
            <div class="text-3xl font-bold tracking-tight leading-none" *ngIf="!showTitle">
                <fa-icon [icon]="getIcon()" size="2x" class="mr-2" *ngIf="subTitleIcon"></fa-icon>
                {{moduleTitle}}
            </div>

            <div class="flex items-center ml-2" *ngIf="showRefreshButton">
                <fa-icon class="text-sm text-red-600 hover:cursor-pointer hover:animate-pulse" [icon]="['fal', 'sync']"
                    (click)="loadDataClick()">
                </fa-icon>
            </div>
        </div>
        <span class="text-sm font-normal text-black" *ngIf="subTitle">{{subTitle}}</span>
    </div>

    <ng-container class="flex items-end">
        <ng-content></ng-content>
    </ng-container>

</div>

<div class="flex-auto ml-2">

    <div class="flex items-center justify-right ml-4 mt-4 sm:mt-0 md:mt-4 mb-4">
        <div class="flex border-2 rounded-full">

            <fa-icon class="icon-size-4 mt-2 ml-2 mr-1 font-light text-slate-300" [icon]="['fal', 'search']" matPrefix>
            </fa-icon>

            <input matInput type="text" class="px-4 py-2 xl:w-50 lg:w-50 md:w-50 sm:w-50 h-auto"
                [(ngModel)]="searchTerm" [autocomplete]="'off'" #searchBar
                placeholder="{{'SYSTEM.RECORD.SEARCH'|translate}}">

            <button matTooltip="{{'SYSTEM.SHOW_FILTER_OPTIONS' | translate}}"
                class="px-4 text-black  border-l hover:cursor-pointer" color="warn" (click)="showFilterClick()"
                *ngIf="showFilterButton">
                <fa-icon [icon]="['fal', 'filter']" class="icon-size-4 mt-2 text-tangaroa"></fa-icon>
            </button>

            <button class="px-4 text-black border-l hover:cursor-pointer" color="primary" *ngIf="showEditButton"
                (click)="editButtonClick()">
                <fa-icon [icon]="['fal', 'check-double']" class="icon-size-5 mt-2 text-yellow-500"></fa-icon>
            </button>

            <button class="px-4 text-black border-l hover:cursor-pointer" color="primary" *ngIf="showDisplayType"
                (click)="showTableViewTypeClick()">
                <fa-icon [icon]="['fal', listCardState ? 'table' : 'address-card']"
                    class="icon-size-5 mt-2 text-yellow-500"></fa-icon>
            </button>

            <button class="px-4 text-black border-l hover:cursor-pointer" color="primary" *ngIf="showAddButton"
                (click)="addButtonClick()">
                <fa-icon [icon]="['fal', 'plus']" class="icon-size-5 mt-2 text-indigo-500"></fa-icon>
            </button>

            <button class="px-4 text-black border-l hover:cursor-pointer" color="primary" *ngIf="showQuickCreateButton"
                (click)="quickCreateButtonClick()" matTooltip="{{'TRACKITEM.QUICK_CREATE' | translate}}">
                <fa-icon [icon]="['fal', 'bolt']" class="icon-size-5 mt-2 text-yellow-500"></fa-icon>
            </button>

            <button class="px-4 text-black border-l hover:cursor-pointer" color="primary" *ngIf="showActionButton"
                (click)="actionButtonClick()">
                <fa-icon [icon]="['fal', 'map-signs']" class="icon-size-5 mt-2 text-indigo-500"></fa-icon>
            </button>

            <button class="px-4 text-black border-l hover:cursor-pointer" color="accent" *ngIf="showExportButton"
                (click)="showTableExportClick()">
                <fa-icon [icon]="['fal', 'file-export']" class="icon-size-4 text-green-800"></fa-icon>
            </button>
        </div>
    </div>

</div>